export const IranSvg = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="16.167"
      height="3.664"
      viewBox="0 0 16.167 3.664"
    >
      <g id="Group_12203" data-name="Group 12203" transform="translate(0 0)">
        <path
          id="Path_1648"
          data-name="Path 1648"
          d="M-3223.412-2468.545h-.955v-3.664h.955Z"
          transform="translate(3239.58 2472.21)"
        />
        <path
          id="Path_1650"
          data-name="Path 1650"
          d="M-3223.412-2468.545h-.955v-3.664h.955Z"
          transform="translate(3231.002 2472.21)"
        />
        <path
          id="Path_1650-2"
          data-name="Path 1650"
          d="M-3223.412-2471.392h-.955v-.817h.955Z"
          transform="translate(3226.851 2473.437)"
        />
        <path
          id="Path_1650-3"
          data-name="Path 1650"
          d="M-3223.412-2471.392h-.955v-.817h.955Z"
          transform="translate(3237.623 2475.054)"
        />
        <path
          id="Path_1650-4"
          data-name="Path 1650"
          d="M-3223.412-2471.392h-.955v-.817h.955Z"
          transform="translate(3235.713 2475.057)"
        />
        <path
          id="Path_1649"
          data-name="Path 1649"
          d="M-3230.345-2468.2h-.955v-2.185h4.664v-.522h.955v1.477h-4.664Z"
          transform="translate(3239.892 2471.857)"
        />
        <path
          id="Path_1651"
          data-name="Path 1651"
          d="M-3232.92-2467.552h-5.924v-2.435h.955v1.48h4.014v-1.48h.955Z"
          transform="translate(3238.844 2471.213)"
        />
      </g>
    </svg>
  );
};
